export const FEATURE_SHOW_JOB_COUNT_SEARCH_ENABLED = false;
export const FEATURE_JOB_AD_CLICK_STATISTICS_ENABLED = false;
